import React, { useEffect } from "react";
import "./header.style.css";
import MobileSidebar from "../mobileheader/mobile-header.component";
import { Link } from "react-router-dom";
import { Menu, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useState } from "react";
import { withRouter } from "react-router-dom";
const HeaderComponent = (props) => {
  const { location } = props;

  const menu = (
    <Menu >
      <Link className="nav-link" to="/medical-services">
        {location.pathname.includes("/medical-services") ? (
          <Menu.Item className="cursor_pointer">
            <span style={{ color: "rgb(0, 140, 211)" }}>
              Home Medical Services
            </span>
          </Menu.Item>
        ) : (
          <Menu.Item className="cursor_pointer">
            Home Medical Services
          </Menu.Item>
        )}
      </Link>
      <Link className="nav-link" to="/telecommunication-services">
        {location.pathname.includes("/telecommunication-services") ? (
          <Menu.Item className="cursor_pointer">
            <span style={{ color: "rgb(0, 140, 211)" }}>
              Telecommunication Services
            </span>
          </Menu.Item>
        ) : (
          <Menu.Item className="cursor_pointer">
            Telecommunication Services
          </Menu.Item>
        )}
      </Link>
    </Menu>
  );
  const [openSidebar, setOpenSidebar] = useState(false);
  const openSidebarMenu = () => {
    setOpenSidebar(true);
    let open = document.getElementById("modalOpen");
    open.classList.add("mobileNavOpen");
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (
      document.body.scrollTop > 50 ||
      document.documentElement.scrollTop > 50
    ) {
      document.getElementById("myP").className = "header_freeze_background";
    } else {
      document.getElementById("myP").className = "header_freeze";
    }
  };
  return (
    <div id="myP" className="header_freeze">
      {/* Header 1 code */}
      <nav className="navbar navbar-expand-lg h2-nav" style={{ zIndex: "10" }}>
        <a className="navbar-brand" href="/">
          <img
            style={{
              width: "70px",
              boxShadow: "0px 0px 37px -10px rgba(0,0,0,0.2)",
            }}
            src={require("../../assets/images/Logo.png")}
          ></img>
        </a>
        <button
          className="navbar-toggler toggler_menu"
          type="button"
          onClick={openSidebarMenu}
        >
          <img src={require("../../assets/images/hamburger.svg")}></img>
        </button>
        <div className="collapse navbar-collapse hover-dropdown" id="header2">
          <ul className="navbar-nav">
            <li className="nav-item active">
              <Link className="nav-link" to="/howitworks">
                {location.pathname.includes("/howitworks") ? (
                  <span style={{ color: "rgb(0, 140, 211)" }}>
                    How it works
                  </span>
                ) : (
                  <span>How it works</span>
                )}
              </Link>
            </li>
            <li className="nav-item dropdown position-relative">
              <Dropdown overlay={menu}>
                <a
                  className="ant-dropdown-link nav-link"
                  onClick={(e) => e.preventDefault()}
                >
                  Home Services <DownOutlined />
                </a>
              </Dropdown>
              {/* <Link className="nav-link" to="/">
                Home Services
              </Link> */}
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/blog">
                {location.pathname.includes("/blog") ? (
                  <span style={{ color: "rgb(0, 140, 211)" }}>Blogs</span>
                ) : (
                  <span>Blogs</span>
                )}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">
                {location.pathname === "/contact" ? (
                  <span style={{ color: "rgb(0, 140, 211)" }}>Contact Us</span>
                ) : (
                  <span>Contact Us</span>
                )}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact/FAQS">
                {location.pathname === "/contact/FAQS" ? (
                  <span style={{ color: "rgb(0, 140, 211)" }}>FAQs</span>
                ) : (
                  <span>FAQs</span>
                )}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/offers">
                {location.pathname === "/offers" ? (
                  <span style={{ color: "rgb(0, 140, 211)" }}>Offers</span>
                ) : (
                  <span>Offers</span>
                )}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/offering">
                {location.pathname === "/offering" ? (
                  <span style={{ color: "rgb(0, 140, 211)" }}>Outsourcing Services</span>
                ) : (
                  <span>Outsourcing Services</span>
                )}
              </Link>
            </li>
          </ul>
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active mr-0">
              <a href="https://apps.apple.com/pk/app/dawa-asaan/id1528679507" target="blank">
                <img className="img-fluid imag_header_width" src={require("../../assets/images/ios.png")}></img>
              </a>
            </li>
            <li className="nav-item active play-btn">
              <a href="https://play.google.com/store/apps/details?id=com.novatorsols.dawaasaan" target="blank">
                <img className="img-fluid imag_header_width" src={require("../../assets/images/google.png")}></img>
              </a>
            </li>
          </ul>
        </div>
      </nav>
      {/* End Header 1 code */}
      <MobileSidebar
        openSidebar={openSidebar}
        setOpenSidebar={setOpenSidebar}
      ></MobileSidebar>
    </div>
  );
};
export default withRouter(HeaderComponent);
